import React, { Component } from 'react';
import { Button, Dimmer, Image, Loader, Modal } from 'semantic-ui-react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { history } from '../../helpers';
import './PremiumDialog.css';
import Strings from '../../common/Strings';
import config from '../../config';
import { paymentActions } from '../../actions';

class PremiumDialog extends Component {
  componentDidMount() {
    this.props.dispatch(paymentActions.getPremiumCheckOutSession());
  }

  onToken = token => {
    history.push('#');
    this.props.dispatch(paymentActions.subscribePremiumPlan(token));
  };

  proceedToCheckOut = () => {
    if (this.props.session !== null) {
      const stripe = window.Stripe(config.STRIPE_PUBLIC_KEY);
      const checkOut = stripe
        .redirectToCheckout({
          sessionId: this.props.session.id,
        })
        .then(function(result) {
          this.props.dispatch(
            paymentActions.sessionCheckoutCleared(this.props.session),
          );
        });
    }
  };

  onClose = () => {
    if (this.props.backOnClose) {
      history.goBack();
    } else {
      history.push('#');
    }
  };

  render() {
    let subscriptionModal;
    let upgradeButton;
    if (this.props.session) {
      upgradeButton = (
        <Button
          className="common-green-button"
          disabled={!this.props.session}
          onClick={() => {
            this.proceedToCheckOut();
          }}
        >
          {Strings.BILLING.upgradeNow}
        </Button>
      );
    } else {
      upgradeButton = (
        <Button className="common-green-button" loading>
          {Strings.BILLING.upgradeNow}
        </Button>
      );
    }
    if (this.props.subscription.status == 'inactive') {
      subscriptionModal = (
        <Modal.Content>
          <div className="common-modal-root">
            <p className="common-modal-title">{Strings.BILLING.modalTitle}</p>
            <div className="premium-modal-section">
              <Image
                className="premium-modal-section-image"
                src="/icon/premium_projects.png"
              />
              <div className="premium-modal-section-info-container">
                <p className="premium-modal-section-title">
                  {Strings.BILLING.modalProjectsTitle}
                </p>
                <p className="premium-modal-section-body">
                  {Strings.BILLING.modalProjectsBody}
                </p>
              </div>
            </div>
            <div className="premium-modal-section">
              <Image
                className="premium-modal-section-image"
                src="/icon/premium_contributors.png"
              />
              <div className="premium-modal-section-info-container">
                <div className="premium-modal-section">
                  <p className="premium-modal-section-title">
                    {Strings.BILLING.modalContributorsTitle}
                  </p>
                </div>
                <p className="premium-modal-section-body">
                  {Strings.BILLING.modalContributorsBody}
                </p>
              </div>
            </div>
            <div className="premium-modal-button-container">
              <Button className="common-grey-button" onClick={this.onClose}>
                {Strings.BILLING.maybeLater}
              </Button>
              <div style={{ width: 30 }} />
              {(this.props.paymentCard && (
                <Button
                  className="common-green-button"
                  onClick={() => {
                    this.props.dispatch(paymentActions.subscribePremiumPlan());
                    this.onClose();
                  }}
                >
                  {Strings.BILLING.upgradeNow}
                </Button>
              )) || <div>{upgradeButton}</div>}
            </div>
          </div>
        </Modal.Content>
      );
    } else if (
      this.props.subscription.status === 'active' &&
      this.props.subscription.cancelAtPeriodEnd
    ) {
      const restore = () => {
        this.props.dispatch(paymentActions.restoreSubscription());
        this.onClose();
      };
      subscriptionModal = (
        <Modal.Content>
          <div className="common-modal-root">
            <p className="common-modal-title">{Strings.BILLING.modalTitle}</p>
            <div className="premium-modal-section">
              <Image
                className="premium-modal-section-image"
                src="/icon/premium_projects.png"
              />
              <div className="premium-modal-section-info-container">
                <p className="premium-modal-section-title">
                  {Strings.BILLING.modalProjectsTitle}
                </p>
                <p className="premium-modal-section-body">
                  {Strings.BILLING.modalProjectsBody}
                </p>
              </div>
            </div>
            <div className="premium-modal-section">
              <Image
                className="premium-modal-section-image"
                src="/icon/premium_contributors.png"
              />
              <div className="premium-modal-section-info-container">
                <div className="premium-modal-section">
                  <p className="premium-modal-section-title">
                    {Strings.BILLING.modalContributorsTitle}
                  </p>
                </div>
                <p className="premium-modal-section-body">
                  {Strings.BILLING.modalContributorsBody}
                </p>
              </div>
            </div>
            <div className="premium-modal-button-container">
              <Button className="common-grey-button" onClick={this.onClose}>
                {Strings.BILLING.maybeLater}
              </Button>
              <div style={{ width: 30 }} />

              <Button className="common-green-button" onClick={restore}>
                {Strings.BILLING.restoreSubscription}
              </Button>
            </div>
          </div>
        </Modal.Content>
      );
    }
    return (
      <Modal
        centered
        size="small"
        open={
          this.props.subscription.status !== 'active' ||
          this.props.subscription.cancelAtPeriodEnd
        }
        closeIcon
        onClose={this.onClose}
      >
        {subscriptionModal}
      </Modal>
    );
  }
}

PremiumDialog.propTypes = {
  dispatch: PropTypes.func.isRequired,
  email: PropTypes.string,
  backOnClose: PropTypes.bool,
  subscription: PropTypes.shape({
    status: PropTypes.string.isRequired,
  }).isRequired,
  subscriptionLoading: PropTypes.bool.isRequired,
  paymentCard: PropTypes.shape({}),
  session: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
  uid: PropTypes.string.isRequired,
};

PremiumDialog.defaultProps = {
  email: '',
  backOnClose: false,
  paymentCard: null,
  session: null,
  uid: '',
};

const mapStateToProps = state => ({
  email: state.user.email,
  subscription: state.premiumSubscription.subscription,
  subscriptionLoading: state.premiumSubscription.loading,
  paymentCard: state.paymentCards.card,
  session: state.premiumSubscription.session,
  uid: state.user.uid,
});

export default connect(mapStateToProps)(PremiumDialog);



// WEBPACK FOOTER //
// ./src/components/dialog/PremiumDialog.js